const STORAGE_KEY = 'resqly_pending_referral_code';

export function normalizeReferralCode(code) {
  return (code || '').trim().toUpperCase();
}

export function storeReferralCode(code) {
  const normalized = normalizeReferralCode(code);
  if (normalized) {
    localStorage.setItem(STORAGE_KEY, normalized);
  }
}

export function getStoredReferralCode() {
  return localStorage.getItem(STORAGE_KEY) || '';
}

export function clearReferralCode() {
  localStorage.removeItem(STORAGE_KEY);
}

export function buildReferralLink(code) {
  const base = typeof window !== 'undefined' ? window.location.origin : 'https://www.resqly.in';
  return `${base}/r/${normalizeReferralCode(code)}`;
}

export async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  return true;
}

export function openWhatsAppShare(message, url) {
  const text = `${message}\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
}

export function formatReferralStatus(status) {
  const map = {
    pending: 'Pending',
    active: 'Active',
    qualified: 'Qualified',
    recorded: 'Activity',
  };
  return map[status] || status || 'Activity';
}
